import { createApp } from 'vue';
// Vuetify
import '@mdi/font/css/materialdesignicons.css';
import 'vuetify/styles';
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import SPSearchApp from './spare-parts/SPSearchApp.vue';
main();
function main() {
    var _a;
    const rootEl = document.querySelector('[data-sp-search-root]');
    if (!rootEl) {
        console.warn('SPSearch: Root element not found');
        return;
    }
    const scriptEl = rootEl.querySelector('script[type="application/json"]');
    if (!scriptEl) {
        console.warn('SPSearch: Configuration not found');
        return;
    }
    try {
        const config = JSON.parse(scriptEl.textContent);
        if (!config || (!((_a = config.rest) === null || _a === void 0 ? void 0 : _a.endpoints) || !config.i18n || !config.session_token)) {
            throw new Error('Invalid configuration');
        }
        const baseColors = {
            'duskBlue': '#003087',
            'vibrantRed': '#ea2b06',
            'jetBlack': '#2a2a2a',
            'warmLightGray': '#f1eee6',
            'warmLightGray-lighten': '#f6f4f0',
            'sunsetYellow': '#FFA800',
            'cloudCruise': '#6cace4',
            'skyChaserOrange': '#fe5000',
            'militaryGreen': '#4b5d3f',
        };
        const vuetify = createVuetify({
            components,
            directives,
            theme: {
                themes: {
                    light: {
                        dark: false,
                        colors: Object.assign(Object.assign({}, baseColors), { 'on-warmLightGray': baseColors['jetBlack'], 'on-warmLightGray-lighten': baseColors['jetBlack'], 'on-sunsetYellow': baseColors['jetBlack'] })
                    }
                }
            }
        });
        createApp(SPSearchApp, { config })
            .use(vuetify)
            .mount(rootEl);
        applyOuterEffects();
    }
    catch (e) {
        console.error('SPSearch configuration error:', e);
        return;
    }
}
function applyOuterEffects() {
    var _a;
    (_a = document.querySelector('.siteHeaderMobile')) === null || _a === void 0 ? void 0 : _a.classList.remove('is--sticky');
    const styleEl = document.createElement('style');
    // language=CSS
    styleEl.textContent = `
        .grecaptcha-badge,
        #CookiebotWidget:not(.CookiebotWidget-open) {
            display: none !important;
        }
    `;
    document.head.appendChild(styleEl);
}
